<template>
  <b-modal v-model="show" :title="`Close Claim CLM-${String(claimId || 0).padStart(4, '0')}`" @ok="handleSubmit" ok-title="Close Claim" ok-variant="primary" :ok-disabled="!form.status || !form.resolutionType" centered>
    <div class="form-group">
      <label>Close as</label>
      <div class="d-flex flex-column" style="gap: 8px;">
        <b-form-radio v-model="form.status" value="closed_paid">Closed — Paid</b-form-radio>
        <b-form-radio v-model="form.status" value="closed_denied">Closed — Denied</b-form-radio>
      </div>
    </div>
    <validated-multiselect id="resolutionType" label="Resolution Type" v-model="form.resolutionType" :options="resolutionTypeOptions" />
    <validated-input id="amountRecovered" label="Amount Recovered ($)" mask="price" v-model="form.amountRecovered" />
    <validated-input id="closeNote" label="Add Note (optional)" type="textarea" v-model="form.note" />
  </b-modal>
</template>

<script>
import ValidatedMultiselect from '@/components/shared/ValidatedMultiselect.vue';
import ValidatedInput from '@/components/shared/ValidatedInput.vue';

export default {
  name: 'ClaimCloseModal',
  components: { ValidatedMultiselect, ValidatedInput },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Boolean, default: false },
    claimId: { type: Number, default: null },
  },
  data() {
    return {
      show: false,
      form: { status: null, resolutionType: null, amountRecovered: null, note: '' },
    };
  },
  computed: {
    resolutionTypeOptions() {
      return [
        { value: null, label: '— Select —' },
        { value: 'paid', label: 'Paid' },
        { value: 'partial', label: 'Partial' },
        { value: 'denied', label: 'Denied' },
        { value: 'escalated', label: 'Escalated' },
      ];
    },
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) this.form = { status: null, resolutionType: null, amountRecovered: null, note: '' };
    },
    show(val) {
      if (!val) this.$emit('input', false);
    },
  },
  methods: {
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.form.status || !this.form.resolutionType) return;
      this.$emit('submit', { ...this.form });
      this.$emit('input', false);
    },
  },
};
</script>
